// Client mirror of server/lib/calendlyLink.js — keep the math identical.
// Prefills the org Calendly link with the lead's identity (name/email/a1
// phone) and stamps utm tracking so the booking webhook matches this lead
// EXACTLY (utm_content = leadId) when the booking comes back.

const formatPhoneForPrefill = (phone) => {
  const d = String(phone || '').replace(/\D/g, '');
  if (d.length === 10)
    return `(${d.slice(0, 3)}) ${d.slice(3, 6)}-${d.slice(6)}`;
  if (d.length === 11 && d.startsWith('1')) {
    return `(${d.slice(1, 4)}) ${d.slice(4, 7)}-${d.slice(7)}`;
  }
  return phone ? String(phone) : '';
};

export const buildCalendlyUrl = (
  baseUrl,
  lead,
  { source = 'board', senderUserId = null } = {},
) => {
  const base = String(baseUrl || '').trim();
  if (!base) return null;

  let url;
  try {
    url = new URL(base);
  } catch (e) {
    return null;
  }

  const name =
    `${lead?.leadFirstName || ''} ${lead?.leadLastName || ''}`.trim();
  if (name) url.searchParams.set('name', name);
  if (lead?.leadEmail) url.searchParams.set('email', lead.leadEmail);
  const phone = formatPhoneForPrefill(lead?.leadPhone);
  if (phone) url.searchParams.set('a1', phone);

  url.searchParams.set('utm_source', 'veritas');
  url.searchParams.set('utm_medium', source);
  if (lead?.leadId) url.searchParams.set('utm_content', lead.leadId);
  // Booking-attribution sender stamp (2026-08-31): rides back on the
  // webhook as utm_term so the booking credits whoever sent/opened the link.
  if (senderUserId) url.searchParams.set('utm_term', senderUserId);

  return url.toString();
};
